<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; padding-left: 50px; font-size: 14px;" :flat='true'>
        <!-- <v-row>
          <v-col cols="12" >
            <h3> 
  			    	<b style="padding-left: 10px !important;">По итогам Курчатовского форума «Исследования с применением синхротронного излучения, нейтронов и электронов» (Курчатов ФСНЭ 2025) опубликован сборник тезисов.</b>
	      		</h3>
          </v-col>
        </v-row>


        <v-row>
          <b class="ml-4" style="padding-left: 10px !important;">Сборник доступен на сайте Научной электронной библиотеки 
            <a href="https://www.elibrary.ru/item.asp?id=89070564">Elibrary.ru по ссылке</a></b>


        </v-row>
        <v-row>
          <b class="ml-4" style="padding-left: 10px !important;">Или скачайте сборник в формате PDF:  
            <a href="https://api.kcsni-service.ru/media/rsini/%D0%A2%D0%B5%D0%B7%D0%B8%D1%81%D1%8B_%D0%A4%D0%A1%D0%9D%D0%AD_2025.pdf">Тезисы ФСНЭ 2025.pdf</a></b>
        </v-row>
 -->

      <p>Отобранные Программным комитетом материалы в авторской редакции будут напечатаны в сборнике тезисов, индексируемом в РИНЦ. <b> На тезисы доклада необходимо загрузить сканированную копию экспертного заключения о возможности открытого опубликования <a href="https://rsini.ru/personal-data">в личном кабинете</a>, а оригинал передать оргкомитету при очной регистрации на Форум.</b> Лицензионный договор о передаче права использования материалов, подписанный всеми авторами и соавторами <b>не требуется</b>.
      </p>

      <v-chip
        dark
        outlined
        label
        color="#ff810a"
        style="margin-left: -20px; margin-bottom: 6px;"
      >
          <h3 :style="{color: $mainColor}"><b>Требования к тезисам</b></h3>
      </v-chip>
      <!-- <h3>
        Требования к тезисам
      </h3> -->
      <p>
        Оформление тезисов должно строго соответствовать <a href="https://api.kcsni-service.ru/media/static/theses_FSNI_2023.doc">образцу</a>.
      </p>
      <p>Тезисы загружаются участниками <a href="https://rsini.ru/personal-data">в личном кабинете</a> (опция доступна после регистрации).</p>
      <p>Тезисы необходимо загрузить в двух форматах: в *.doc (*.docx) и *.pdf. Максимальный объем тезисов доклада 1 страница (Times New Roman, 14pt), не более 2000 знаков, включая пробелы. </p>
      <p>Тезисы принимаются до  <b :style="{color: $mainColor}">21 октября 2026 г.</b></p>

      <v-chip
        dark
        outlined
        label
        color="#ff810a"
        style="margin-left: -20px; margin-bottom: 6px;"
      >
          <h3 :style="{color: $mainColor}"><b>Стендовые доклады</b></h3>
      </v-chip>
      <!-- <h3>Стендовые доклады</h3> -->
      <p>Рекомендуемый формат стендовых докладов (постеров): вертикальный, формат А1 (ширина 60 см, высота 84 см).</p>
      <p>Лучшим стендовым докладам будет дана возможность рассказать о своих исследованиях в устном формате перед всей аудиторией.</p>







      </v-card>
  </div>
</template>
<script>

export default {
  name: 'Theses',
  data: () => ({
  }),

};
</script>
<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
